import * as React from "react";
import PropTypes from "prop-types";

export const ChangePasswordSuccess = ({ changed, onClose }) => {
    if (changed) {
        return (<div id="passwordChangeAlert">
            <div role="alert" className="alert alert-success">
                <strong>Success</strong>
                <div className="message"> Your password has been changed.</div>
                <a onClick={onClose}>Close this window</a></div>
        </div>);
    }
    else return null;
};

ChangePasswordSuccess.propTypes = {
    show: PropTypes.bool
};

ChangePasswordSuccess.defaultProps = {
    changed: false
};

export default ChangePasswordSuccess;
